import * as React from 'react';
import styled from 'styled-components';
import { IResort, ICurrency } from './types';
import { priceWithCommas } from '../utils/commonHelper';
import t from './locales';
import { getLocale } from '../utils/pathHelper';

const View = styled.a`
  display: flex;
  align-items: center;
  border-radius: 0.25em;
  border: 1px solid var(--gray300);
  background-color: var(--gray0);
  padding: 0.5em;
  font-size: 0.875em;
  margin-bottom: 0.5em;
  text-decoration: none;
  color: var(--gray900);
  &:hover {
    text-decoration: none;
    color: var(--gray900);
    background-color: var(--gray100);
  }
  .image {
    position: relative;
    min-width: 4.5em;
    min-height: 4.5em;
    border-radius: 0.25em;
    margin-right: 1em;
    background-color: var(--gray200);
    background-size: cover;
    background-position: center center;
  }
  .rating {
    position: absolute;
    right: 0.25em;
    bottom: 0.25em;
    widtH: 2em;
    height: 2em;
    background-color: var(--blue400);
    border-radius: 0.25em;
    border-top-left-radius: 0.75em;
    color: var(--gray0);
    line-height: 2em;
    text-align: center;
    font-size: 0.825em;
  }
  .snow-item {
    font-size: 0.75em;
    margin: 0;
  }
`;

interface IProps {
  resort: IResort;
  currency: ICurrency;
}

const ResortItem: React.FC<IProps> = (props) => {
  const { resort, currency } = props;
  const { rate } = currency;
  const { code, image, rating, lift_min_price } = resort;

  function renderPrice(price: number|null) {
    const locale = getLocale();
    if (price == null) { return null };
    if (locale.toString() == 'ja') {
      return `${priceWithCommas(price)}円`;
    } else {
      return `${priceWithCommas(price * rate)}〜 (JPY ${Math.round(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}～)`;
    };
  }

  const liftMinPrice = renderPrice(lift_min_price);

  return (
    <View href={`/snow/resorts/${code}`} target="_blank" rel="noopener noreferrer">
      <div className="image" style={{ backgroundImage: `url(${image})` }}>
        {rating && <div className="rating">{rating}</div>}
      </div>
      <div>
        {resort.name}
        {liftMinPrice &&
          <p className="snow-item">
            {t.lift()} {currency.code} {liftMinPrice}
          </p>}
      </div>
    </View>
  );
}

export default ResortItem;
